import React from 'react';

export default function useUserFullName(user) {
  return React.useMemo(() => {
    return !user ? '' : [user.name, user.familyName].join(' ');
  }, [user]);
}
